import React, { type FC } from "react"

import { TitleSlideTemplate } from "../../SlideTemplates/TitleSlide"

export const Title: FC = () => (
  <TitleSlideTemplate
    heading="Progress Over Perfection"
    subHeading="Your first steps in accessibility"
  />
)
